import React from 'react';

const ErrorMessage: React.FC<{
  errors: string | undefined;
}> = ({ errors }) => {
  return (
    <>{errors && <p className="text-xs text-red-500 mt-1">{errors}</p>}</>
  );
};

export default ErrorMessage;
